import { Messages } from './../utilities/messages';
import { CommonConstants } from './../utilities/commonConstants';
import { Injectable } from '@angular/core';
import { ConfigService } from './../services/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieHandlerService } from './../services/cookieHandler.service';
import { SessionHandlerService } from './sessionHandler.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Injectable({
    providedIn: 'root'
})
export class PincodeHandlerService {
    public LocationErrorMessage: string;
    public IsUnSupportedCityOrState: boolean;
    public IsUnSupportedCountry: boolean;
    public IsDeclarationGiven: boolean;
    public DeviceLatitude;
    public DeviceLongitude;
    public GeoLocationDetails;
    constructor(
        private _http: HttpClient,
        private _cookieHandler: CookieHandlerService,
        private _sessionHandlerService: SessionHandlerService
    ) { }
    public OnPinCodeChanged($event, callback) {
        const pinCodeValue = $event.target.value || '';
        this.LocationErrorMessage = null;
        this.IsUnSupportedCityOrState = false;
        if (pinCodeValue && pinCodeValue.toString().length === 6) {
            this.getLocationBasedOnPinCode(pinCodeValue)
                .subscribe((response) => {
                    this.handleGeoLocationReponse(response);
                    callback();
                });
        }
    }
    private handleGeoLocationReponse(mtResponse) {

        if (!mtResponse.hasOwnProperty('errorCode')) {
            this.updateLocationValues(mtResponse);
        } else if (mtResponse.errorCode) {
            this.handleInvalidPinCode();
        }
    }
    private handleUnSupportedCityOrState(response: GeoLocationDetails) {
        this.IsUnSupportedCityOrState = true;
        this.IsUnSupportedCountry = true;
        this.updateLocationValues(response);
        this.IsDeclarationGiven = false;
        this.LocationErrorMessage = Messages.LocationErrorMessages.UnSupportedCity;
    }
    private handleUnSupportedCountry() {
        this.IsUnSupportedCountry = true;
        this.IsDeclarationGiven = false;
        this.LocationErrorMessage = Messages.LocationErrorMessages.UnSupportedCountry;
    }
    private handleInvalidPinCode() {
        this.LocationErrorMessage = Messages.LocationErrorMessages.InvalidPin;
        this.GeoLocationDetails = null;
    }
    private updateLocationValues(response: GeoLocationDetails) {
        this.GeoLocationDetails = response;
    }
    private getLocationBasedOnPinCode(pinCode: number) {
        const url = ConfigService.getInstance().getConfigObject()
            .APIURL.getGeoLocationBasedOnPin.replace('{0}', pinCode.toString());
        const options = { headers: this.getHeaders() };
        return this._http.get(url, options)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                })
            );
    }
    private getHeaders = (): HttpHeaders => {
        const headerObj: HttpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'cmptcorrid': '',
            'authtoken': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken),
            'guardtoken': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.GuardToken),
            'x-audit-loc-latitude': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.latitude)?this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.latitude):'',
            'x-audit-loc-longitude': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.longitude)?this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.longitude):'',
               
        });
        return headerObj;
    }
}
